import { BaseResource } from "./base.resource";

export class Person extends BaseResource {
  userId: string;
  principalName: string;
  displayName: string;
  cai: string;
  phone: string;
  email: string;
  organization: string;
  office: string;
  type: string;

  constructor(options?: any) {
    super(options);
  }

  public static extractCai(value: string) {
    if (!value) return null;
    value = value.trim().toUpperCase();
    if (value.length == 4) return value;
    if (value.startsWith("CT")) return value.substring(3);
    let caiIndex = value.lastIndexOf("(");
    if (caiIndex === -1) return null;
    return value.substring(caiIndex + 1, value.length - caiIndex - 2);
  }
}
